module.exports = __webpack_public_path__ + "img/tag.3a92e01a.svg";